import classNames from 'classnames'
import { ProjectDetailEventTimePeriod } from 'enums/app'
import { FC, memo } from 'react'
import { isWeekend } from 'utils/date'

type DataCellProps = React.PropsWithChildren<{
  data: {
    startDate: Date
  }
  currentView: string
}>

export const DataCell: FC<DataCellProps> = memo((props) => {
  return (
    <div
      className={classNames(
        'w-full h-full',
        isWeekend(props.data.startDate) && 'crew-scheduler-weekend'
      )}
    >
      {props.currentView === ProjectDetailEventTimePeriod.Monthly.value &&
        props.data.startDate.getDate()}
    </div>
  )
})
